import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";

export const loadCustomerStatus = ({ commit, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/contactStatus/collection', state.customerStatus).then((response) => {
            if(!response.fromState) commit(types.LOAD_CUSTOMER_STATUS, response.data.status)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createCustomerStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/contactStatus', data).then((response) => {
            commit(types.ADD_CUSTOMER_STAT, response.data.status)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateCustomerStatus = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/contactStatus/${data.id}`, data).then((response) => {
            commit(types.UPDATE_CUSTOMER_STAT, response.data.status)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteCustomerStatus = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/contactStatus/${id}`).then((response) => {
            commit(types.DELETE_CUSTOMER_STAT, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

